type PropType = {
  icon: string;
  heading: string;
  main: string;
};

const HowItWorksCard = ({ heading, icon, main }: PropType) => {
  return (
    <div className="flex flex-col items-center md:items-start gap-4">
      <img src={icon} alt="" className="w-8 h-8" />
      <h2 className="head text-base font-bold">{heading}</h2>
      <h3 className="text-sm font-normal">{main}</h3>
    </div>
  );
};

export default HowItWorksCard;
